var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.fieldname)?_c('p',{staticClass:"filter-tit"},[_vm._v("\n    "+_vm._s(_vm.fieldname)+"\n  ")]):_vm._e(),_c('cube-checkbox-group',{attrs:{"shape":"square","options":_vm.options},on:{"input":_vm.changeHandle},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }